import React from 'react'
import { AudioContext } from './AudioContext'
import { parse } from 'subtitle'
import { getPercent, between } from './helpers'

class AudioPlayer extends React.Component {
  constructor(props) {
    super(props)

    this.playlist = new Map()

    this.addToPlaylist = file => {
      const audio = new Audio(file)
      this.playlist.set(file, audio)

      return audio
    }

    this.playCurrent = file => {
      const audio = this.playlist.get(file)

      this.playlist.forEach(item => {
        if(item !== audio) {
          item.pause()
        }
      })
    }

    this.unmount = file => {
      const audio = this.playlist.get(file)
      audio.src = ''
      this.playlist.delete(file)
    }

    this.setText = text => this.setState({ currentText: text })

    this.state = {
      currentText: '',
      setText: this.setText,
      addToPlaylist: this.addToPlaylist,
      playCurrent: this.playCurrent,
      unmount: this.unmount,
    }
  }

  render() {
    return (
      <AudioContext.Provider value={this.state}>
        {this.props.children}
      </AudioContext.Provider>
    )
  }
}


export default AudioPlayer
